import React, { useState, useEffect, useRef } from 'react';
import { ThemeColors } from '../../../../Context/ThemeContext';
import { PeriodOption } from './PeriodDropdown';

interface UniversalFilterProps {
  onChangeAll: (value: PeriodOption) => void;
  theme: ThemeColors;
}

export const UniversalFilter: React.FC<UniversalFilterProps> = ({ onChangeAll, theme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const options: PeriodOption[] = ['1D', '7D', '30D', '90D'];

  const labels: Record<PeriodOption, string> = {
    '1D': '1 Day (24h)',
    '7D': '7 Days (1 week)',
    '30D': '30 Days (1 month)',
    '90D': '90 Days (3 months)',
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: 'relative', zIndex: 20 }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
          color: '#fff',
          padding: '8px 16px',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
        }}
      >
        <span style={{ fontSize: '14px' }}>⚡</span>
        Set All Filters
        <span
          style={{
            fontSize: '10px',
            transform: isOpen ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s',
          }}
        >
          ▼
        </span>
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '40px',
            left: '0',
            background: theme.card,
            border: `1px solid ${theme.border}`,
            borderRadius: '6px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
            overflow: 'hidden',
            minWidth: '120px',
          }}
        >
          <div
            style={{
              padding: '8px 12px',
              fontSize: '11px',
              color: theme.textSecondary,
              borderBottom: `1px solid ${theme.border}`,
              fontWeight: 500,
            }}
          >
            Apply to all cards
          </div>
          {options.map((option) => (
            <button
              key={option}
              onClick={() => {
                onChangeAll(option);
                setIsOpen(false);
              }}
              style={{
                display: 'block',
                width: '100%',
                padding: '10px 12px',
                background: 'transparent',
                color: theme.text,
                border: 'none',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: 500,
                textAlign: 'left',
                transition: 'background 0.2s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = '#2563eb20')}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
              {labels[option]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
